module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Dopo il tramonto")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("Di Mary Calmes")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("Seguito di "), _c('i', [_vm._v("Tempo al tempo")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_c('span', {
    staticClass: "C_Current__And__White_Background"
  }, [_vm._v("Un libro della serie Tempo al tempo")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sono passati due anni da quando Stefan Joss si è trasferito nel sud degli Stati Uniti per amore del rancher Rand Holloway. Stef ha cercato – con esitazione – di adeguarsi alla sua nuova vita, ma il vero amore non fila mai liscio come dovrebbe. Rand vuole che lui rimanga a casa al ranch, Stef vuole avere una rete di sicurezza nel caso Rand decida di sbarazzarsi di lui. Finalmente, dopo aver capito di essere stato ingiusto a dubitare di lui, Stef decide di impegnarsi sul serio con Rand e l’uomo è al settimo cielo.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Quando Stef ha l’opportunità di provare il suo amore, non si tira indietro, mettendo a repentaglio la sua stessa vita. E Rand ha la possibilità di dimostrare che – a volte – la vita può sorprenderti quando meno te lo aspetti.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 57
// module chunks = 0